import React from 'react';
import { useNavigate as useRouterNavigate } from 'react-router-dom';
export const useNavigate = () => {
    const navigate = useRouterNavigate();
    return navigate;
};
export const useNavigateBack = () => {
    const navigate = useRouterNavigate();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    return React.useCallback(() => {
        navigate({
            pathname: '..',
        }, {
            relative: 'route',
        });
    }, [navigate]);
};
